/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an area chart from pasted data — filled trends over time, no sign-up.`)
};

const es_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de área a partir de datos pegados — tendencias rellenas a lo largo del tiempo, sin registro.`)
};

const de_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Flächendiagramm aus eingefügten Daten — gefüllte Trends über die Zeit, keine Anmeldung erforderlich.`)
};

const nl_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een vlakdiagram van geplakte data — gevulde trends over tijd, geen registratie nodig.`)
};

const fr_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique en aires à partir de données collées — tendances remplies dans le temps, sans inscription.`)
};

const it_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico ad area dai dati incollati — tendenze riempite nel tempo, senza registrazione.`)
};

const pt_br2_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de área a partir de dados colados — tendências preenchidas ao longo do tempo, sem cadastro.`)
};

const pt_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de área a partir de dados colados — tendências preenchidas ao longo do tempo, sem registo.`)
};

const ja_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貼り付けたデータからエリアチャートを作成します — 時系列の塗りつぶし表示、登録不要。`)
};

const zh_area_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据粘贴的数据创建面积图——随时间变化的填充趋势，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_tool_description", locale)
	if (locale === "en") return en_area_tool_description(inputs)
	if (locale === "es") return es_area_tool_description(inputs)
	if (locale === "de") return de_area_tool_description(inputs)
	if (locale === "nl") return nl_area_tool_description(inputs)
	if (locale === "fr") return fr_area_tool_description(inputs)
	if (locale === "it") return it_area_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_area_tool_description(inputs)
	if (locale === "pt") return pt_area_tool_description(inputs)
	if (locale === "ja") return ja_area_tool_description(inputs)
	return zh_area_tool_description(inputs)
};